import type { ReactNode } from 'react';
import { ExperienceCard } from './ExperienceCard';
import { homeCardToListItem } from '../utils/cardAdapter';
import type { HomeExperienceCard } from '../types';

interface ExperienceCarouselProps {
  /** Aceita ReactNode pra permitir embeded de <span class="title-serif">…</span>. */
  title: ReactNode;
  description?: string;
  items: HomeExperienceCard[];
}

export function ExperienceCarousel({ title, description, items }: ExperienceCarouselProps) {
  if (items.length === 0) return null;

  return (
    <section className="section">
      <div className="section-head">
        <div>
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>
      </div>
      <div className="carousel" role="list">
        {items.map((card) => (
          <div key={card.experienceCode} className="carousel__item" role="listitem">
            <ExperienceCard exp={homeCardToListItem(card)} />
          </div>
        ))}
      </div>
    </section>
  );
}
